import { useEffect } from 'react';

export default (title) => {
  useEffect(() => {
    if (title) {
      document.title = title + (!title.match(/RTIC$/i) ? ' | RTIC' : '');
    }
  }, [title])
};